import React, { useState, useEffect } from 'react';

const Story2 = () => {

  return (
    <div className="story-container">
      <p className="story-header">I believe in meeting people where they’re at.</p>
      <p className="story-text">In the galleries or at home, well-designed tech can help spark curiosity- especially for those who don’t consider themselves “museum people”.</p>
    </div>
  )
}

export default Story2;